import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingSpinner: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="glass-page-bg flex items-center justify-center">
            <div className="text-center">
                {/* Logo with enhanced animation */}
                <div className="relative mb-6">
                    {/* Multiple rotating rings for more dynamic effect */}
                    <div className="w-24 h-24 mx-auto relative">
                        {/* Outer pulsing ring */}
                        <div className="absolute inset-0 rounded-full border-4 border-blue-200 dark:border-blue-800 animate-pulse opacity-60"></div>

                        {/* Main spinning ring */}
                        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 dark:border-t-blue-400 animate-spin"></div>

                        {/* Secondary spinning ring (opposite direction) */}
                        <div className="absolute inset-1 rounded-full border-4 border-transparent border-b-purple-500 dark:border-b-purple-400 animate-spin-reverse"></div>

                        {/* Glowing effect ring */}
                        <div className="absolute inset-0 rounded-full border-2 border-blue-400 dark:border-blue-300 animate-ping opacity-40"></div>

                        {/* Logo in center with enhanced effects */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="relative">
                                <img
                                    src="/images/logo192.png"
                                    alt={t('components.loadingSpinner.logoAlt')}
                                    className="w-10 h-10 animate-pulse"
                                />
                                {/* Glowing effect around logo */}
                                {/*<div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-400 to-purple-400 opacity-20 animate-pulse"></div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingSpinner;